import { EMAILS } from '../../global/support/EMAILS';

export const MCP_OAUTH_COPY = {
	INVALID_REQUEST_TITLE: 'Invalid Request',
	MCP_NOT_AVAILABLE: 'MCP Not Available',
	// eslint-disable-next-line max-len
	MCP_NOT_AVAILABLE_MESSAGE: `This feature is not currently enabled on your account. Please contact your Customer Success Manager or reach out to ${EMAILS.SUPPORT} to get it enabled.`,
	MISSING_REQUIRED_PARAMS: 'Missing required OAuth parameters.',
	OAUTH_ACCESS: 'Access account information',
	OAUTH_EXECUTE: 'Execute actions on your behalf',
	OAUTH_READ: 'Read and manage your data',
	REQUESTING_ACCESS: (clientName: string) =>
		`By allowing access, ${clientName} will be able to interact with your Arovy Account via MCP.`,
	WANTS_TO_CONNECT: (clientName: string) => `${clientName} wants to connect to Arovy`
};
